import { render, staticRenderFns } from "./RFPConfirmationPage.vue?vue&type=template&id=53410c79"
import script from "./RFPConfirmationPage.vue?vue&type=script&lang=js"
export * from "./RFPConfirmationPage.vue?vue&type=script&lang=js"
import style0 from "./RFPConfirmationPage.vue?vue&type=style&index=0&id=53410c79&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports